import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { getStoredLang } from './utils/getLangBySubdomain';

const fallbackLng = getStoredLang()
localStorage.setItem('lang', fallbackLng)

//split namespaces: only the ones the landing needs block the first paint; the big page-specific
//ones (order 12KB, FAQ 7KB, policy 19KB) are warmed in the background so they're ready before the
//user reaches those pages, without competing with the landing's critical JS/CSS on mobile
const CRITICAL_NS = ['main', 'UI', 'meta', 'errors']
const DEFERRED_NS = ['order', 'FAQ', 'policy']

//i18nReady resolves once the critical namespaces are loaded. index.jsx waits on it before
//hydrating a prerendered page, so the client's first render has the same translations that are
//baked into the static HTML (otherwise hydration would mismatch and flash the raw keys).
export const i18nReady = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng,
    ns: CRITICAL_NS,
  })

i18nReady.then(() => i18n.loadNamespaces(DEFERRED_NS))

export default i18n